import type { ListingDetail } from '../lib/api';
import { groupNumber } from '../lib/format';
import { Icon } from './Icon';

/** Иконки ключевых характеристик (по ключу атрибута категории). */
const SPEC_ICONS: Record<string, string> = {
  mileage: 'gauge',
  year: 'calendar',
  transmission: 'gear',
  fuel: 'fuel',
  rooms: 'door',
  area_m2: 'ruler',
  land_sotix: 'ruler',
  floor: 'layers',
  memory_gb: 'chip',
  head_count: 'paw',
};
/** Порядок важности: что показывать крупными плитками (не больше трёх). */
const SPEC_PRIORITY = ['mileage', 'year', 'transmission', 'area_m2', 'rooms', 'floor', 'land_sotix', 'memory_gb', 'head_count', 'fuel'];

export interface SplitAttributes {
  specs: { key: string; icon: string; label: string; value: string }[];
  tags: string[];
}

/** Ключевые характеристики — плитками с иконками (как на макете), остальные — тегами. */
export function splitAttributes(attrs: ListingDetail['attributes'], conditionLabel: string | null): SplitAttributes {
  const ranked = attrs
    .filter((a) => SPEC_ICONS[a.key] && a.display && a.display !== '—')
    .sort((a, b) => SPEC_PRIORITY.indexOf(a.key) - SPEC_PRIORITY.indexOf(b.key))
    .slice(0, 3);
  const used = new Set(ranked.map((a) => a.key));
  const tags = attrs
    .filter((a) => !used.has(a.key) && a.display && a.display !== '—')
    .map((a) => (a.value === true ? a.label : typeof a.value === 'number' ? `${a.label}: ${a.display}` : a.display));
  if (conditionLabel) tags.unshift(conditionLabel);
  const show = (a: ListingDetail['attributes'][number]) =>
    typeof a.value === 'number' ? `${groupNumber(a.value)}${a.display.replace(/^[\d.,\s]+/, '') ? ` ${a.display.replace(/^[\d.,\s]+/, '')}` : ''}` : a.display;
  return { specs: ranked.map((a) => ({ key: a.key, icon: SPEC_ICONS[a.key]!, label: a.label, value: show(a) })), tags };
}

export function SpecTiles({ specs }: { specs: SplitAttributes['specs'] }) {
  if (!specs.length) return null;
  return (
    <div className={`spec-tiles n${specs.length}`}>
      {specs.map((s) => (
        <div key={s.key} className="spec-tile">
          <Icon name={s.icon} size={20} className="spec-icon" />
          <span className="spec-text">
            <span className="spec-label">{s.label}</span>
            <span className="spec-value">{s.value}</span>
          </span>
        </div>
      ))}
    </div>
  );
}
